import React, { useEffect } from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Gallery from "@/pages/Gallery";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Team from "@/pages/Team";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { CustomerSegmentProvider } from "@/context/CustomerSegmentContext";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

function App() {
  return (
    <LanguageProvider>
      <CustomerSegmentProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/dienstleistungen" element={<Services />} />
              <Route path="/dienstleistungen/:slug" element={<ServiceDetail />} />
              <Route path="/referenzen" element={<Gallery />} />
              <Route path="/team" element={<Team />} />
              <Route path="/ueber-uns" element={<About />} />
              <Route path="/kontakt" element={<Contact />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </CustomerSegmentProvider>
    </LanguageProvider>
  );
}

export default App;
